import { render, staticRenderFns } from "./GovernatesTable.vue?vue&type=template&id=f7a88a36&"
import script from "./GovernatesTable.vue?vue&type=script&lang=js&"
export * from "./GovernatesTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports